"use strict";
var PopStore_1 = require('../PopStore');
var closest = require('closest');
var PopChainManager = (function () {
    function PopChainManager() {
    }
    PopChainManager.prototype.isNestedPop = function (pop) {
        return closest(pop.targetEl, '[pop]', true);
    };
    PopChainManager.prototype.getPopChain = function (pop, hideFullChain) {
        var popChain = [];
        if (hideFullChain) {
            pop = this._getRootPop(pop);
        }
        else {
            pop = this._getFirstUnpinnedUnhoveredParentPop(pop);
        }
        var stack = [];
        stack.push(pop);
        while (!!stack.length) {
            pop = stack.pop();
            if (!!pop.childPops.length) {
                pop.childPops.forEach(function (child, index) {
                    stack.push(child);
                });
            }
            popChain.push(pop);
        }
        return popChain;
    };
    PopChainManager.prototype.maybePinOrUnpinPopAndParentPops = function (target, pin) {
        var groupId = target.getAttribute('popgun-group');
        var pop = PopStore_1.default.get(groupId);
        pop.isPinned = pin;
        !!pin ? target.setAttribute('pinned-pop', '') : target.removeAttribute('pinned-pop');
        if (pop.parentPop) {
            this.maybePinOrUnpinPopAndParentPops(pop.parentPop.targetEl, pin);
        }
    };
    PopChainManager.prototype.removeParentChildRelationship = function (pop) {
        if (!!pop.parentPop) {
            var index = pop.parentPop.childPops.indexOf(pop);
            if (index !== -1) {
                pop.parentPop.childPops.splice(index, 1);
            }
            pop.parentPop = null;
        }
    };
    PopChainManager.prototype.setParentChildRelationship = function (parent, child) {
        this._setParentPop(parent, child);
        this._addChildPop(parent, child);
    };
    PopChainManager.prototype._setParentPop = function (parent, child) {
        child.parentPop = parent;
    };
    PopChainManager.prototype._addChildPop = function (parent, child) {
        parent.childPops.push(child);
    };
    PopChainManager.prototype._getRootPop = function (pop) {
        if (!!pop) {
            while (!!pop.parentPop) {
                pop = pop.parentPop;
            }
            return pop;
        }
    };
    PopChainManager.prototype._getFirstUnpinnedUnhoveredParentPop = function (pop) {
        while (!!pop.parentPop && !pop.parentPop.isPinned && !pop.parentPop.popOver.element.querySelector(':hover')) {
            pop = pop.parentPop;
        }
        return pop;
    };
    return PopChainManager;
}());
exports.PopChainManager = PopChainManager;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new PopChainManager();
